var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('out-put-page',{staticClass:"landscape",attrs:{"orientation":"landscape","title":"Étude financière\n"}},[_c('section',{staticClass:"landscape"},[_c('h3',[_vm._v(" CPC Prévisionnel ")]),_c('data-table',{attrs:{"tables":_vm.cpc,"isCpc":true}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }